import React from "react";

import CustomSpinner from "../custom-spinner/custom-spinner";

export const ModalCustomSpinner = () => (
    <div className="modal-custom-spinner-container">
        <CustomSpinner />
    </div>
);
